exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".status-alerts[data-v-54486778]{font-size:18px;flex-direction:column}.alert[data-v-54486778]{padding:10px;margin-bottom:10px;border-radius:5px;color:#fff}.alert-danger-text[data-v-54486778]{color:#d9534f}.alert-info-text[data-v-54486778]{color:#2a6fde}.alert-warning[data-v-54486778]{background-color:#f0ad4e}.alert strong[data-v-54486778]{margin-right:5px}@keyframes blink-data-v-54486778{0%,to{opacity:1}50%{opacity:0}}.blink[data-v-54486778]{animation:blink-data-v-54486778 1s infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54486778","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ocean-insights/StatusAlerts.vue
// module id = 1608
// module chunks = 0